
import axios from "axios";
import { OutputBaseProps } from "utils/types/API";
import { SeoItemProps } from ".";

interface ApiSeoCreateInputProps extends Omit<SeoItemProps, "id"> {
}

type ApiSeoCreateOutputProps = OutputBaseProps<{ item: SeoItemProps; }, ApiSeoCreateInputProps>

export const apiSeoCreate = async (data: ApiSeoCreateInputProps) => {
    const res = (await axios.post<ApiSeoCreateOutputProps>("/api/seo/create", data))
        .data;
    return res;
};